/**
 * Null External Provider - no-op implementation
 */
export class NullExternalProvider {
    winHelp(_helpFile) { }
    winHelpKey(_helpFile, _key) { }
    callWin(_cmdLine) { }
    viewOpen(_fileName, _title) { }
    viewClose() { }
    writeFile(_fileName, _content) { }
}
//# sourceMappingURL=external.js.map